import styled, { css } from 'styled-components';
import {
  CompanyOutline,
  ExecutiveSmallOutline,
} from '@simplywallst/ui-core/icons';

interface Type {
  type: 'bought' | 'sold';
}

const svg = css<Type>`
  width: ${({ theme }) => theme.x3spacePx}px;
  height: ${({ theme }) => theme.x3spacePx}px;
  > * {
    fill: ${({ theme, type }) =>
      type === 'bought' ? theme.color.good : theme.color.warning};
  }
`;

export const ExecutiveSVG = styled(ExecutiveSmallOutline)<Type>`
  ${svg}
`;

export const CompanySVG = styled(CompanyOutline)<Type>`
  ${svg}
`;
